<template>
  <AuthPageLayout>
    <h2>
      <i18next :translation="$t('auth:title.signin')">
        <template #cutr>
          <span class="text-amber-600">Cutr</span>
        </template>
      </i18next>
    </h2>
    <Callout v-if="isMaintenanceModeEnabled" variant="warning" icon="info">
      <p>{{ $t('auth:callout.maintenance') }}</p>
    </Callout>
    <Callout v-if="$route.query.redirect" icon="info">
      {{ $t('auth:callout.selectOrganisation') }}
    </Callout>
    <h3>{{ $t('auth:actions.selectOrganisation') }}</h3>
    <SelectOrganisationBox
      :afterOrganisationSelected="afterOrganisationSelected"
    /><CButton
      color="white"
      width="fluid-width"
      iconBefore
      icon="west"
      @click="$router.back()"
    >
      {{ $t('common:actions.back') }}
    </CButton>
  </AuthPageLayout>
</template>

<script setup lang="ts">
import AuthPageLayout from '@/components/common/AuthPageLayout.vue';
import { useRouter, useRoute } from '@/composables/plugins';
import SelectOrganisationBox from '@/components/elements/SelectOrganisationBox.vue';
import { useMaintenanceMode } from '@/composables/useMaintenanceMode';

const isMaintenanceModeEnabled = useMaintenanceMode();

const router = useRouter();
const route = useRoute();

const afterOrganisationSelected = async () => {
  await router.push((route.query?.redirect as string) || '/home');
};
</script>
